<template>
    <td>
        <div class="flex items-center gap-1">
            <!-- performance value -->
            <span class="min-w-14 max-w-16 text-left">{{ result?.BestPerformance }}</span>
            <!-- record badges -->
            <div
                class="text-content/60 grid grid-flow-row auto-rows-max grid-cols-2 place-items-center gap-x-4 text-[0.6rem]"
            >
                <span v-for="record in records" :key="record">{{ record }}</span>
            </div>
        </div>
    </td>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { IResult } from "../../interfaces/wdl-archive.interfaces";

const props = withDefaults(
    defineProps<{
        result?: IResult;
    }>(),
    {}
);

const records = computed(() => props.result?.RecordFlag?.split(","));
</script>

<style lang="scss"></style>
